import { Permission } from '~/types/Permission';
import { User } from '~/types/User';

import { checkIsSuperAdmin } from '../checkIsSuperAdmin';

export const checkIsRbac: Permission = (user: User) => !checkIsSuperAdmin(user);
